module.exports = __webpack_public_path__ + "teqbahn-assets/media/icon.a26348d6.png";